<template>
  <div>
    <div v-if="statusShow">
      <div class="buttonList">
        <Button type="primary" size="small" @click="effective('1')">有效</Button>
        <Button type="warning" size="small" @click="effective('2')">待定</Button>
        <Button type="error" size="small" @click="effective('3')">无效</Button>
        <!--<Poptip trigger="click" placement="left-start">-->
          <!--<Button type="error" size="small">无效</Button>-->
          <!--<div slot="content">-->
            <!--<i-Input placeholder="备注"></i-Input>-->
            <!--&lt;!&ndash;<Button  @click="invalidSubmit(item.dicName,item.dicCode)" v-for="item in invalid" :key="item.dicCode" type="primary" size="small" class="btnReastStyle">{{item.dicName}}</Button>&ndash;&gt;-->
          <!--</div>-->
        <!--</Poptip>-->
      </div>

      <!-- 备注 -->
      <Modal title="备注" v-model="memoModal" width="360" @on-visible-change="clearText">
        <i-Input v-model="memo" type="textarea" :rows="3" placeholder="备注"></i-Input>
        <Select v-if="typeValue == 3" v-model="invalidSelect" style="margin-top:10px;" placeholder="请选择无效原因">
          <Option v-for="item in invalid" :key="item.dicCode" :value="item.dicName">{{item.dicName}}</Option>
        </Select>
        <div slot="footer">
          <Button type="primary" @click="submitOk" long>确定</Button>
        </div>
      </Modal>
    </div>
    <span v-if="!statusShow">
    </span>
  </div>
</template>

<script>
  import {ButtonGroup} from 'iview'
  import {mapGetters} from 'vuex'
  import axios from 'axios'

  export default {
    name: "render-filter",
    props: {
      filterData: {
        type: Object
      }
    },
    components:{ButtonGroup},
    computed: {
      ...mapGetters(['pageDict', 'storeRunoff']),

      screenData() {
        return this.filterData
      },

      statusShow(){
        let statusShow = false
        if(this.filterData.row.statusid == 0 || this.filterData.row.statusid == 98){
          statusShow = true
        }else{
          statusShow = false
        }
        return statusShow
      },

      invalid(){
        return this.pageDict.commonMap.invalidReason
      },
    },
    data() {
      return {
        memo: '',
        memoModal: false,
        typeValue: '',
        invalidSelect:'',
      }
    },
    methods: {

      //
      effective(val) {
        this.memoModal = true
        this.typeValue = val
      },

      //无效原因
      invalidSubmit(val,id){
        this.memo = val
        this.typeValue = '3'
        this.submitOk()
      },

      //提交
      submitOk() {
        if(this.typeValue == '3' && !this.invalidSelect){
          this.$Message.warning('请选择无效原因')
          return false
        }
        let body = {}
        if(this.typeValue == '3'){
          body.content = this.invalidSelect
          body.reason = this.memo
        }else{
          body.content = this.memo
        }
        this.$http.post("/client/update_kz_valid_status", {
          type: this.typeValue,
          kzid: this.screenData.row.kzid,
          ...body,
          collectorId: this.screenData.row.collectorid,
          channelName: this.pageDict.channelMap[this.screenData.row.channelid].channelName,
          channelId: this.screenData.row.channelid,
          sourceId:this.screenData.row.sourceid,
          sourceName:this.pageDict.sourceMap[this.screenData.row.sourceid].srcName,
          kzName: this.screenData.row.kzname,
          kzWeChat: this.screenData.row.kzwechat,
          kzQq: this.screenData.row.qq,
          kzPhone: this.screenData.row.kzphone,
        }).then((data) => {
          if (data.code === 100000) {
            this.memoModal = false
            this.clearText()
            this.$Message.success(data.msg)
            this.$bus.emit('pull-kz-data',{page:true})
          } else {
            this.$Message.error(data.msg)
          }
        })
      },

      //备注关闭后清空
      clearText(status) {
        if (!status) {
          this.memo = ''
          this.typeValue = ''
          this.invalidSelect = ''
        }
      },
    }
  }
</script>

<style scoped>
  .buttonList {
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
  }
  .btnReastStyle{
    display: block;
    margin-bottom:6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/render-components/render-filter.vue